export const SERVER_VERSION_FETCH_TIMEOUT_MS = 4000;
export const WARM_BOOT_SCOPE = "boot";
export const TECHNICAL_RELOAD_PREPARE_WINDOW_MS = 18000;
export const BEFORE_UNLOAD_BYPASS_WINDOW_MS = 12000;
export const NEXT_CONTROLLER_TIMEOUT_MS = 8000;
export const SW_ACTIVATION_ACK_TIMEOUT_MS = 2500;
